import { MasterAPI } from "@/api/master";
import { QueryKeys } from "@/network/queryKeys";
import { useQuery } from "react-query";

type tReturnValue = {
  masters: {
    _id: string;
    dist: number;
    premium: boolean;
    user: {
      avatar?: string;
      first_name: string;
      last_name?: string;
      sex?: boolean;
    };
  }[];
};
export const useSimilarMastersQuery = (masterId: string) => {
  return useQuery(
    [QueryKeys.similarMasters, masterId],
    () => MasterAPI.getSimilarMasters(masterId) as Promise<tReturnValue>,
    {
      enabled: !!masterId,
    }
  );
};
